import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { LayoutDashboard, Columns, Users, Trophy, Menu } from 'lucide-react';
export function BottomNav() {
  const location = useLocation();
  const navItems = [{
    path: '/',
    label: 'Home',
    icon: LayoutDashboard
  }, {
    path: '/kanban',
    label: 'Kanban',
    icon: Columns
  }, {
    path: '/clientes',
    label: 'Clientes',
    icon: Users
  }, {
    path: '/ranking',
    label: 'Ranking',
    icon: Trophy
  }, {
    path: '/configuracoes',
    label: 'Menu',
    icon: Menu
  }];
  return <div className="md:hidden fixed bottom-0 left-0 right-0 bg-background-lighter border-t border-white/5 z-50 px-4 pb-safe" data-id="element-84">
      <div className="flex justify-between items-center h-16" data-id="element-85">
        {navItems.map(item => {
        const isActive = location.pathname === item.path;
        const Icon = item.icon;
        return <Link key={item.path} to={item.path} className={`
                flex flex-col items-center justify-center w-full h-full space-y-1
                ${isActive ? 'text-primary' : 'text-text-muted'}
              `} data-id="element-86">
              <Icon className={`h-5 w-5 ${isActive ? 'fill-current' : ''}`} data-id="element-87" />
              <span className="text-[10px] font-medium" data-id="element-88">{item.label}</span>
            </Link>;
      })}
      </div>
    </div>;
}